function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import styled from '@emotion/styled';
// 컴팩트 모드 임계값 상수
export var COMPACT_THRESHOLD_CODE_PX = 400;
export var COMPACT_THRESHOLD_CODE = "".concat(COMPACT_THRESHOLD_CODE_PX, "px");
// 메인 코드 컨테이너 스타일
export var CodeContainer = styled.div(function(param) {
    var theme = param.theme;
    var _theme_shadows;
    var _theme_shadows_sm;
    var _obj;
    return _define_property({
        position: 'relative',
        margin: "".concat(theme.spacing.md, " 0"),
        borderRadius: theme.radius.md,
        overflow: 'hidden',
        border: "1px solid ".concat(theme.isDark ? '#555' : theme.border),
        boxShadow: (_theme_shadows_sm = (_theme_shadows = theme.shadows) === null || _theme_shadows === void 0 ? void 0 : _theme_shadows.sm) !== null && _theme_shadows_sm !== void 0 ? _theme_shadows_sm : 'none',
        'pre': (_obj = {
            margin: '0 !important',
            padding: "".concat(theme.spacing.md, " !important"),
            borderRadius: '0 !important',
            backgroundColor: "".concat(theme.isDark ? '#1E1E1E' : theme.paperLight, " !important"),
            color: theme.text,
            fontSize: theme.typography.fontSize.sm
        }, _define_property(_obj, "@media (max-width: ".concat(theme.breakpoints.sm, ")"), {
            fontSize: theme.typography.fontSize.xs,
            padding: "".concat(theme.spacing.sm, " !important")
        }), _define_property(_obj, "@container (max-width: ".concat(COMPACT_THRESHOLD_CODE, ")"), {
            fontSize: theme.typography.fontSize.xs,
            padding: "".concat(theme.spacing.sm, " !important")
        }), _define_property(_obj, 'code', {
            lineHeight: '1.4 !important',
            backgroundColor: 'transparent !important'
        }), _obj)
    }, "@container (max-width: ".concat(COMPACT_THRESHOLD_CODE, ")"), {
        margin: "0",
        borderRadius: '0',
        boxShadow: 'none'
    });
});
// 상단 바 스타일
export var TopBar = styled.div(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.isDark ? '#3a3a3a' : theme.paperLight,
        padding: "".concat(theme.spacing.xs, " ").concat(theme.spacing.md),
        color: theme.isDark ? '#ccc' : theme.textSecondary,
        fontSize: theme.typography.fontSize.xs,
        borderBottom: "1px solid ".concat(theme.isDark ? '#555' : theme.border),
        zIndex: 5,
        position: 'relative'
    }, _define_property(_obj, "@media (max-width: ".concat(theme.breakpoints.sm, ")"), {
        padding: "".concat(theme.spacing.xs, " ").concat(theme.spacing.sm)
    }), _define_property(_obj, "@container (max-width: ".concat(COMPACT_THRESHOLD_CODE, ")"), {
        padding: "".concat(parseFloat(theme.spacing.xs) * 0.5, "rem ").concat(theme.spacing.sm),
        fontSize: theme.typography.fontSize.xs
    }), _obj;
});
// 언어 이름 스타일
export var LanguageName = styled.span(function(param) {
    var theme = param.theme;
    return {
        fontWeight: theme.typography.fontWeight.bold,
        textTransform: 'uppercase'
    };
});
// 복사 버튼 스타일
export var CopyButton = styled.button(function(param) {
    var theme = param.theme;
    return _define_property({
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing.xs,
        padding: "".concat(parseFloat(theme.spacing.xs) * 0.5, "rem ").concat(theme.spacing.xs),
        borderRadius: theme.radius.sm,
        transition: "background-color ".concat(theme.transition.fast, ", color ").concat(theme.transition.fast),
        '&:hover': {
            backgroundColor: theme.isDark ? '#555' : theme.paperHover,
            color: theme.isDark ? '#fff' : theme.text
        },
        svg: {
            width: '14px',
            height: '14px'
        }
    }, "@container (max-width: ".concat(COMPACT_THRESHOLD_CODE, ")"), {
        gap: 0,
        padding: "".concat(parseFloat(theme.spacing.xs) * 0.5, "rem"),
        'span': {
            display: 'none'
        }
    });
});
// Mermaid 다이어그램 컨테이너 스타일
export var MermaidContainer = styled.div(function(param) {
    var theme = param.theme;
    return _define_property({
        padding: theme.spacing.md,
        backgroundColor: theme.paper,
        border: "1px solid ".concat(theme.border),
        borderRadius: theme.radius.md,
        margin: "".concat(theme.spacing.md, " 0"),
        textAlign: 'center',
        svg: {
            maxWidth: '100%',
            height: 'auto'
        }
    }, "@container (max-width: ".concat(COMPACT_THRESHOLD_CODE, ")"), {
        padding: theme.spacing.sm,
        margin: "".concat(theme.spacing.sm, " 0"),
        borderRadius: theme.radius.sm
    });
});
// 선택 영역 전송 버튼 스타일
export var SelectionSendButton = styled.button(function(param) {
    var theme = param.theme;
    var _theme_shadows;
    var _theme_shadows_sm;
    return {
        position: 'absolute',
        zIndex: 10,
        background: theme.primary,
        color: '#fff',
        border: 'none',
        borderRadius: theme.radius.sm,
        padding: "".concat(theme.spacing.xs, " ").concat(theme.spacing.sm),
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing.xs,
        fontSize: theme.typography.fontSize.xs,
        boxShadow: (_theme_shadows_sm = (_theme_shadows = theme.shadows) === null || _theme_shadows === void 0 ? void 0 : _theme_shadows.sm) !== null && _theme_shadows_sm !== void 0 ? _theme_shadows_sm : 'none',
        transition: "background-color ".concat(theme.transition.fast),
        '&:hover': {
            backgroundColor: theme.primaryDark
        },
        svg: {
            width: '14px',
            height: '14px'
        }
    };
});
